import PropTypes, { number } from 'prop-types';
// material-ui
import { styled, useTheme } from '@mui/material/styles';
import { Avatar, Box, List, ListItem, ListItemAvatar, ListItemText, Typography } from '@mui/material';
import useCountUp from 'hooks/useCountUp';
// project imports
import MainCard from 'ui-component/cards/MainCard';
import TotalIncomeCard from 'ui-component/cards/Skeleton/TotalIncomeCard';
import IconifyIcon from './IconifyIcon';

// styles
const CardWrapper = styled(MainCard)(({ theme, cardColor, textColor }) => ({
  backgroundColor: cardColor || theme.palette.primary.dark,
  color: textColor || theme.palette.primary.light,
  overflow: 'hidden',
  position: 'relative',
  '&:after': {
    content: '""',
    position: 'absolute',
    width: 210,
    height: 210,
    background: `linear-gradient(210.04deg, ${theme.palette.primary[200]} -50.94%, rgba(144, 202, 249, 0) 83.49%)`,
    borderRadius: '50%',
    top: -30,
    right: -180,
  },
  '&:before': {
    content: '""',
    position: 'absolute',
    width: 210,
    height: 210,
    background: `linear-gradient(140.9deg, ${theme.palette.primary[200]} -14.02%, rgba(144, 202, 249, 0) 77.58%)`,
    borderRadius: '50%',
    top: -160,
    right: -130,
  },
}));

// ==============================|| DASHBOARD - TOTAL INCOME DARK CARD ||============================== //

const TotalIncomeDarkCard = ({ isLoading, bgColor, textColor, title, value, icon, unit=null }) => {
  const theme = useTheme();
  const currentValue = useCountUp({ start: 0, end: value || '-', duration: 2, separator: ',' });

  return (
    <>
      {isLoading ? (
        <>
          <TotalIncomeCard />
        </>
      ) : (
        <CardWrapper border={false} content={false} cardColor={bgColor} textColor={textColor}>
          <Box sx={{ p: 2 }}>
            <List sx={{ py: 0 }}>
              <ListItem alignItems="center" disableGutters sx={{ py: 0 }}>
                <ListItemAvatar>
                  <Avatar
                    sx={{
                      ...theme.typography.commonAvatar,
                      ...theme.typography.largeAvatar,
                      backgroundColor: '#FFF',
                      // backgroundColor: theme.palette.primary[800],
                      color: '#F00',
                      width: 50,
                      height: 50,
                    }}
                  >
                    <IconifyIcon iconName={icon.iconName} color={icon.color} size={30} />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  sx={{
                    py: 0,
                    mt: 0.45,
                    mb: 0.45,
                  }}
                  primary={
                    <Typography variant="h4" sx={{ color: '#111827' }}>
                      {
                        // value.toLocaleString('en-US')
                      // currentValue.toLocaleString('en-US')
                      currentValue
                      }

                      { unit && (<sub style={{fontSize:'10px', color:'#797B7F'}}>({unit})</sub>) }
                    </Typography>
                  }
                  secondary={
                    <Typography variant="subtitle2" sx={{ color: '#797B7F', mt: 0.25 }}>
                      {title}
                    </Typography>
                  }
                />
              </ListItem>
            </List>
          </Box>
        </CardWrapper>
      )}
    </>
  );
};

TotalIncomeDarkCard.propTypes = {
  isLoading: PropTypes.bool,
};

export default TotalIncomeDarkCard;
